"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author ADr
 */


var ProductSuppliersGroupConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ProductSuppliersGroupConverter, _DataObjectConverter_);

  function ProductSuppliersGroupConverter() {
    _classCallCheck(this, ProductSuppliersGroupConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductSuppliersGroupConverter).apply(this, arguments));
  }

  return ProductSuppliersGroupConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ProductSuppliersGroupConverter = ProductSuppliersGroupConverter;